import { render, staticRenderFns } from "./SumupTab.vue?vue&type=template&id=27a1145e&scoped=true&"
import script from "./SumupTab.vue?vue&type=script&lang=ts&"
export * from "./SumupTab.vue?vue&type=script&lang=ts&"
import style0 from "./SumupTab.vue?vue&type=style&index=0&id=27a1145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1145e",
  null
  
)

export default component.exports